import React, { useEffect } from 'react';

import { Box, HStack, Stack } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { INIT_PAGE_INFO } from 'services/utils/constants';
import { customTheme } from 'theme';

import { Card, PageHeaderWithIcon } from 'components/DataDisplay';
import { Select } from 'components/DataEntry';
import { DataScanIcon } from 'components/Icons';
import { useSearchParamFunctions } from 'containers/App/hooks/useSearchParamFunctions';
import { DataDashboard } from 'containers/Visibility/Data/Components/DataDashboard';
import { DataTabs } from 'containers/Visibility/Data/Components/DataTabs';
import { VISIBILITY_DATA_TAB_STORAGE_KEY } from 'containers/Visibility/Data/Components/utils';
import { showOptions } from 'containers/Visibility/Vulnerabilities/Components/utils';
import { useSearchParams } from 'hooks/useSearchParams';

import { actions } from '../slice';

const VISIBILITY_DATA_SHOW_STORAGE_KEY = 'visibility_data_show';

export const DataDashboardSideNav: React.FC = () => {
  const dispatch = useDispatch();
  const params = useSearchParams<{
    tab: string;
    uuid: string;
    resource_type: string;
    show: string;
  }>();
  const { updateValue } = useSearchParamFunctions();
  const storedVisibilityDataShow = localStorage.getItem(
    VISIBILITY_DATA_SHOW_STORAGE_KEY,
  );
  const storedVisibilityDataTab = localStorage.getItem(
    VISIBILITY_DATA_TAB_STORAGE_KEY,
  );
  const show = params.show || storedVisibilityDataShow || showOptions[0].value;
  const tab = params.tab || storedVisibilityDataTab;

  useEffect(() => {
    updateValue('show', show, VISIBILITY_DATA_SHOW_STORAGE_KEY);
  }, [show, updateValue]);

  useEffect(() => {
    // Apply URL or persisted tab state before the table starts its initial fetch.
    if (!!tab) {
      dispatch(actions.updateSelectedTab(tab));
      dispatch(
        tab === 'Identities'
          ? actions.updateDataSecurityIdentitiesPageInfo(INIT_PAGE_INFO)
          : actions.updateDataTablePageInfo(INIT_PAGE_INFO),
      );
    }
  }, [tab, dispatch]);

  return (
    <>
      <Card>
        <Stack spacing="headerContentSpacing" h="full" w="full">
          <HStack spacing={6} pl={3}>
            <PageHeaderWithIcon label="Data Security" icon={<DataScanIcon />} />
            <HStack>
              <Box color={customTheme.colors.gray['300']}>Show</Box>
              <Box w={40}>
                <Select
                  options={showOptions}
                  value={show === 'Details' ? showOptions[1] : showOptions[0]}
                  onChange={option => {
                    updateValue(
                      'show',
                      option?.value,
                      VISIBILITY_DATA_SHOW_STORAGE_KEY,
                    );
                  }}
                  showClearIndicator={false}
                  showIconInValueContainer
                />
              </Box>
            </HStack>
          </HStack>
          {show === 'Details' ? <DataTabs /> : <DataDashboard />}
        </Stack>
      </Card>
    </>
  );
};
